import { Center, SimpleGrid, Group, Text } from "@mantine/core";
import {
  IconAppWindow,
  IconBadgeVr,
  IconBook,
  IconEyeExclamation,
  IconFileSpreadsheet,
  IconFlagExclamation,
  IconHeadset,
  IconRadar,
  IconTournament,
  IconTimeline, // Added this as a placeholder for LFM icon
} from "@tabler/icons-react";
import { FeatureCard } from "../FeatureCard/FeatureCard";
import accDrive1 from "../../media/academy.png";
import accDrive2 from "../../media/learnatrack.png";
import accDrive3 from "../../media/freepractice.png";
import accDrive4 from "../../media/setupoptimizer.png";
import accDrive5 from "../../media/team_management.png";
import accDrive6 from "../../media/elo_target.png";
import accDrive7 from "../../media/leaderboard.png";
import accDrive8 from "../../media/vr.png";
import LFMLogoWebP from "../../media/lfm-logo.webp";
import { useTranslation } from "react-i18next";
import React from "react";

// Create a custom LFM icon component
// Replace this with your actual LFM SVG if you have one
const LFMIcon = (props: { size?: number; color?: string }) => {
  const { size = 24, color = 'currentColor' } = props;
  
  // This is a placeholder - replace with your actual LFM icon SVG path
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 12h5l2-6 2 6h5"></path>
      <path d="M18 12v6"></path>
      <path d="M21 12v6"></path>
    </svg>
  );
};

export const dynamicFeatureList = {
  title: "features.<id>.title",
  subtitle: "features.<id>.subtitle",
  description: "features.<id>.description",
  modal: "features.<id>.modalText",
  features: [
    {
      id: "feature1",
      icon: IconBook,
      image: accDrive1
    },
    {
      id: "feature2",
      icon: IconFileSpreadsheet,
      image: accDrive2
    },
    {
      id: "feature3",
      icon: IconEyeExclamation,
      image: accDrive3
    },
    {
      id: "feature4",
      icon: IconTournament,
      image: accDrive4
    },
    {
      id: "feature5",
      icon: IconRadar,
      image: accDrive5
    },
    {
      id: "feature6",
      icon: IconFlagExclamation,
      image: accDrive6,
      // Add a flag to indicate this feature needs the special title treatment
      hasCustomTitle: true
    },
    {
      id: "feature7",
      icon: IconAppWindow,
      image: accDrive7
    },
    {
      id: "feature8",
      icon: IconBadgeVr,
      image: accDrive8
    },
  ]
};

export function FeatureCardList() {
  const { t } = useTranslation("translation");
  
  const dynamicFeatureCards = dynamicFeatureList.features.map((feature, index) => {
    // For Feature6, create a custom title component with the LFM icon
    let featureName;
    
    if (feature.hasCustomTitle && feature.id === "feature6") {
      featureName = (
        <Group gap="xs" justify="center">
          <img src={LFMLogoWebP} alt="LFM" width={60} height="auto" style={{ marginRight: "-4px" }} />
          <Text>Elo Target</Text>
        </Group>
      );
    } else {
      featureName = t(dynamicFeatureList.title.replace("<id>", feature.id));
    }
    
    return (
      <Center id={feature.id} key={index}>
        <FeatureCard
          featureName={featureName}
          featureText={t(dynamicFeatureList.subtitle.replace("<id>", feature.id))}
          longText={t(dynamicFeatureList.description.replace("<id>", feature.id))}
          modalText={t(dynamicFeatureList.modal.replace("<id>", feature.id))}
          icon={feature.icon}
          image={feature.image}
        />
      </Center>
    );
  });
  
  return (
    <Center>
      <SimpleGrid
        cols={{ base: 1, sm: 2, lg: 4 }}
        spacing="xs"
        verticalSpacing="xl"
        style={{ maxWidth: "92em", width: '100%' }}>
        {dynamicFeatureCards}
      </SimpleGrid>
    </Center>
  );
}